import get from 'lodash/get';
import moment from 'moment';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import AppDashboard from '../AppDashboard';
import ListAppointmentsScreen from '../../components/scheduling/ListAppointmentsScreen';
import {useGetAppointmentsQuery} from '../../redux/services/appointmentApi';
import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {useGetSessionTypesQuery} from '../../redux/services/sessionTypeApi';

const ListAppointmentsPage = props => {
  const [date, setDate] = useState(moment().format('MM/DD/yyyy'));
  const navigate = useNavigate();
  const appointmentsQuery = useGetAppointmentsQuery({
    start_time: moment(date, 'MM/DD/yyyy')
      .set({hour: 0, minute: 0, second: 0, millisecond: 0})
      .toISOString(),
    end_time: moment(date, 'MM/DD/yyyy')
      .set({hour: 23, minute: 59, second: 59, millisecond: 0})
      .toISOString(),
  });
  const providerQuery = useGetCurrentProviderQuery();
  const provider = get(providerQuery, 'data', null);
  const sessionTypesQuery = useGetSessionTypesQuery(
    {providerId: provider ? provider.id : null},
    {skip: !provider}
  );
  const childProps = {
    ...props,
    sessionTypes: get(sessionTypesQuery, 'data'),
    appointments: get(appointmentsQuery, 'data.data'),
    loading: !appointmentsQuery.data || !sessionTypesQuery.data,
    error: (
      get(appointmentsQuery, 'errors[0]')
      || get(sessionTypesQuery, 'errors[0]')
    ),
    onDateChange: dt => setDate(dt.format('MM/DD/yyyy')),
  };
  return (
    <AppDashboard {...childProps} onBack={() => navigate('/providers')}>
      <ListAppointmentsScreen {...childProps} />
    </AppDashboard>
  );
};

export default ListAppointmentsPage;
